// src/api/useDeleteUser.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/api";

const deleteStudent = async (userId) => {
  return api.delete(`/study-users/${userId}`);
};

export const useDeleteStudentQuery = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteStudent,
    onSuccess: () => {
      // 성공 시 users 쿼리 데이터를 무효화하여 최신 상태로 갱신합니다.
      queryClient.invalidateQueries(["students"]);
    },
  });
};
